<template>
  <div class="row main-content">
    <SocialBar/>
    <InicioComponent/>
  </div>
</template>

<script>
import InicioComponent from './components/InicioComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'Home',
  components: {
    SocialBar,
    InicioComponent
  }
}

</script>